import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-safari-download-modal',
  templateUrl: './safari-download-modal.component.html',
  styleUrl: './safari-download-modal.component.scss',
  standalone: false
})
export class SafariDownloadModalComponent {
  @Input() url: string;

  constructor(public readonly modal: NgbActiveModal) {}


  onClickOpenInNewTab() {
    this.modal.dismiss();
    window.open(this.url, '_blank');
  }

}
